import countries from '../../static/resources/countries.json'

export const supportedCountries = ['AT', 'DE', 'FR', 'FI', 'GB', 'BE', 'SE']

export function getCountriesAsMap() {
  return { ...countries }
}

export function isCountrySupported(countryId: string): boolean {
  return supportedCountries.indexOf(countryId) > -1
}

export const countriesWithinFrenchTerritories: string[] = [
  'FR',
  'NC',
  'PF',
  'WF',
  'RE',
  'YT',
  'PM',
  'GF',
  'MQ',
  'GP',
  'MF',
]

export function areWithinFrenchTerritories(companyCountry: string, customerCountry: string): boolean {
  return (
    countriesWithinFrenchTerritories.includes(companyCountry) &&
    countriesWithinFrenchTerritories.includes(customerCountry)
  )
}

export const countriesWithinEU = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]
